import { useEffect } from "react";
import Routes from "./Routes";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from 'react-query/devtools';
import { getToken, setUserData } from "./utils/storageUtils";
import { getMe } from "./services/users";
import { logoutHelper } from "./utils/logoutHelper";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

/**
 * Au montage : si un access token est présent en localStorage (rechargement
 * de page, retour sur l'app), on vérifie que la session est encore vivante
 * en appelant {@code GET /users/me} et on resynchronise {@code userdata}
 * dans le localStorage. Si l'appel échoue (token révoqué, user supprimé,
 * refresh impossible), {@code apiRequest} déclenche déjà un logout — on
 * reste défensif ici en couvrant les cas non-401 (ex. user introuvable).
 *
 * <p>Note : on ne dispatch pas d'action Redux — la lecture côté composants
 * passe par {@code localStorage.userdata}, pas par le store. À aligner
 * lors de la phase 2.C (user store consolidé).
 */
async function bootstrapSession() {
  if (!getToken()) return;
  try {
    const res = await getMe();
    if (res?.ok && res.data) {
      setUserData(res.data);
      return;
    }
    if (res && res.status >= 400 && res.status < 500 && res.status !== 401) {
      // 401 déjà géré par l'intercepteur (logout). 4xx non-401 (403/404
      // sur /users/me) = session morte côté serveur — on purge.
      // 5xx exclu : c'est de la santé serveur, pas un signal de session ;
      // forcer un logout sur 502/503/500 transitoire faisait perdre les
      // utilisateurs lors de coupures back côté proxy.
      logoutHelper();
    }
  } catch (err) {
    console.error("BootstrapSessionErr: ", err);
  }
}

function App() {
  useEffect(() => {
    bootstrapSession();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Routes />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
